function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Path");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Web",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Patient-Portal-Login",
  transform: "translate(-420.000000, -493.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2",
  transform: "translate(140.000000, 470.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M280.834269,30.1684582 L290.153056,30.1684582 L286.081823,34.239692 C285.756458,34.565057 285.756458,35.0989893 286.081823,35.4243542 C286.407188,35.7497192 286.932777,35.7497192 287.258142,35.4243542 L292.755976,29.9265201 C293.081341,29.6011551 293.081341,29.0755655 292.755976,28.7502005 L287.266485,23.2440237 C286.94112,22.9186588 286.41553,22.9186588 286.090165,23.2440237 C285.7648,23.5693887 285.7648,24.0949783 286.090165,24.4203433 L290.153056,28.4999198 L280.834269,28.4999198 C280.375421,28.4999198 280,28.8753409 280,29.334189 C280,29.7930371 280.375421,30.1684582 280.834269,30.1684582 Z",
  id: "Path"
}))));

var SvgRightChervon = function SvgRightChervon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "13px",
    viewBox: "0 0 13 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRightChervon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/right_chervon.73993c04.svg";
export { ForwardRef as ReactComponent };